export enum DocumentSharePickerMutationTypes {
  ADD_GROUP_TO_SELECTED = 'ADD_GROUP_TO_SELECTED',
  ADD_GROUPS_TO_DISABLED = 'ADD_GROUPS_TO_DISABLED',
  ADD_MEMBERS_TO_DISABLED = 'ADD_MEMBERS_TO_DISABLED',
  ADD_MEMBERS_TO_SELECTED = 'ADD_MEMBERS_TO_SELECTED',
  REMOVE_GROUP_FROM_SELECTED = 'REMOVE_GROUP_FROM_SELECTED',
  REMOVE_MEMBERS_FROM_SELECTED = 'REMOVE_MEMBERS_FROM_SELECTED',
  SET_DISABLED_GROUPS = 'SET_DISABLED_GROUPS',
  SET_DISABLED_MEMBERS = 'SET_DISABLED_MEMBERS',
  SET_HIGHLIGHTED_MEMBER = 'SET_HIGHLIGHTED_MEMBER',
  SET_SELECTED_GROUPS = 'SET_SELECTED_GROUPS',
  SET_SELECTED_MEMBERS = 'SET_SELECTED_MEMBERS',
}
